import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import productService from '../services/productService';

const ProductFormPage = () => {
  const [formData, setFormData] = useState({
    category_id: '',
    name: '',
    description: '',
    stock_quantity: 0,
    min_stock_limit: 10,
    buying_price: 0,
    selling_price: 0,
    unit: 'adet',
    tax_rate: 20
  });
  const [categories, setCategories] = useState([]);
  const navigate = useNavigate();
  const { id } = useParams();

  useEffect(() => {
    const loadData = async () => {
      try {
        const cats = await productService.getAllCategories();
        setCategories(cats);

        if (id) {
          const product = await productService.getById(id);
          setFormData({
            category_id: product.category_id || '',
            name: product.name,
            description: product.description || '',
            stock_quantity: product.stock_quantity,
            min_stock_limit: product.min_stock_limit,
            buying_price: product.buying_price,
            selling_price: product.selling_price,
            unit: product.unit,
            tax_rate: product.tax_rate !== undefined ? product.tax_rate : 20
          });
        }
      } catch (error) {
        toast.error('Veriler yüklenirken hata oluştu.');
      }
    };
    loadData();
  }, [id]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (id) {
        await productService.update(id, formData);
        toast.success('Ürün güncellendi.');
      } else {
        await productService.create(formData);
        toast.success('Ürün oluşturuldu.');
      }
      navigate('/products');
    } catch (error) {
      toast.error(error.response?.data?.message || 'İşlem başarısız.');
    }
  };

  return (
    <div className="container-fluid mt-4">
      <div className="card shadow-sm">
        <div className="card-header bg-white">
          <h4 className="mb-0">{id ? 'Ürün Düzenle' : 'Yeni Ürün Ekle'}</h4>
        </div>
        <div className="card-body">
          <form onSubmit={handleSubmit}>
            <div className="row">
              <div className="col-md-6 mb-3">
                <label className="form-label">Ürün Adı</label>
                <input type="text" name="name" className="form-control" value={formData.name} onChange={handleChange} required />
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Kategori</label>
                <select name="category_id" className="form-select" value={formData.category_id} onChange={handleChange}>
                  <option value="">Seçiniz...</option>
                  {categories.map(cat => (
                    <option key={cat.id} value={cat.id}>{cat.name}</option>
                  ))}
                </select>
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Stok Miktarı</label>
                <input type="number" name="stock_quantity" className="form-control" value={formData.stock_quantity} onChange={handleChange} min="0" />
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Birim</label>
                <select name="unit" className="form-select" value={formData.unit} onChange={handleChange}>
                  <option value="adet">Adet</option>
                  <option value="kg">KG</option>
                  <option value="cuval">Çuval</option>
                </select>
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Alış Fiyatı</label>
                <input type="number" name="buying_price" className="form-control" value={formData.buying_price} onChange={handleChange} min="0" step="0.01" />
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Satış Fiyatı</label>
                <input type="number" name="selling_price" className="form-control" value={formData.selling_price} onChange={handleChange} min="0" step="0.01" />
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">KDV Oranı (%)</label>
                <select name="tax_rate" className="form-select" value={formData.tax_rate} onChange={handleChange}>
                  <option value="0">%0</option>
                  <option value="1">%1</option>
                  <option value="10">%10</option>
                  <option value="20">%20</option>
                </select>
              </div>
              <div className="col-md-6 mb-3">
                <label className="form-label">Kritik Stok Limiti</label>
                <input type="number" name="min_stock_limit" className="form-control" value={formData.min_stock_limit} onChange={handleChange} min="0" />
                <small className="text-muted">Stok bu sayının altına düşerse uyarı verilir.</small>
              </div>
              <div className="col-12 mb-3">
                <label className="form-label">Açıklama</label>
                <textarea name="description" className="form-control" rows="3" value={formData.description} onChange={handleChange}></textarea>
              </div>
            </div>
            <div className="d-flex justify-content-end">
              <button type="button" onClick={() => navigate('/products')} className="btn btn-secondary me-2">İptal</button>
              <button type="submit" className="btn btn-primary">Kaydet</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ProductFormPage;